<template>
  <div class="about">
    <h2 class="about-title">成熟期<span class="about-title__year">2000-2010</span></h2>
    
    <div class="content1 section column-04">
      <div class="column-04__left">
        <p>90年代は日本人ライダーの世界チャンピオンが多く誕生したが、その流れは2000年代に入っても続き、01年には加藤大治郎が世界新記録となるシーズン11勝をマークし、世界王者に輝いた。この功績を称え、モーターサイクルスポーツ界として初めて、文部科学大臣からスポーツ功労者顕彰を贈られた。また、その後もロードレースの世界では、05年、06年と世界耐久選手権で北川圭一、09年にはGP250クラス最後の年に青山博一がチャンピオンを獲得した。</p>
        <p>また、2000年からツインリンクもてぎでトライアル世界戦選手権シリーズが開催されるようになったが、04年にはフジガスこと藤波貴久がシーズン8勝し、日本人初のトライアル世界チャンピオンの座を勝ち取った。藤波にも、当時の文部科学大臣からスポーツ功労者顕彰が授与されている。</p>
      </div>
      <div class="column-04__right">
        <img src="/img/pic01.jpg" alt="">
        <img src="/img/pic02.jpg" alt="">
      </div>
    </div>
    <div class="content2 section column-05">
      <p>一方、国内では05年に全日本選手権競技にエンデューロ、スーパーモタードの新種目が加わり、より幅広い愛好者が楽しめるようになった。さらに全日本ロードレース選手権の最高峰クラスには、02年から年間チャンピオンに文部科学大臣杯が授与されるなど、社会的認知度も高めている。</p>
      <figure><img src="/img/1990-2011-3.jpg" alt="" width="" height=""></figure>
    </div>
    
    <div class="content4 section column-03">
      <div>
        <h3>次世代ライダーの育成</h3>
        <p>底辺拡大にも力が注がれ、次世代の育成に携わる人材を輩出するMFJインストラクターセミナーが03年から始まった。それ以外にも、ロードレースアカデミー、トライアルアカデミーの開校、女性でもレディースモトクロスの全日本併催開催（2000年〜）、レディースロードレースの開催（2008年〜）など普及振興対策が図られた。</p>
        <figure style="margin:0"><img src="/img/1990-2011-8.jpg" alt="" width="" height=""><figcaption>女性への普及を観点にレディースロードレース、レディースモトクロスも開催している</figcaption></figure>
      </div>
      <figure>
          <img src="/img/1990-2011-10.png" alt="" width="" height="">
        <figcaption>次世代ライダーの育成として、ロードレース、トライアルでアカデミーを開講。競技力向上と競技の普及を図っている。<br>また普及の要となるインストラクター育成のため、インストラクターセミナーも定期的に開いている。</figcaption>
      </figure>
    </div>
    <div class="content5 img-content">
      <div class="img-content__bg">
        <div class="img-content__wrap">
        <h3>スポーツ功労賞</h3>
        <p>
          我が国のスポーツの向上と振興に寄与し、特に功績顕著なる者を顕彰するスポーツ功労者顕彰。2021年9月現在、モーターサイクルスポーツでは加藤大治郎、青山博一、藤波貴久の3人が受賞している
        </p>
        <div class="column">
          <div>
            <h4>加藤大治郎</h4>
            <p>
              2000年からWGP(現MotoGP)のGP250クラスにフル参戦をし始め、ランキング3位を獲得すると、翌2001年には11勝を挙げ、世界チャンピオンを獲得した。小柄ながら類まれなライディングセンスを持ち、国内外で絶大な人気を誇った。
            </p>
          </div>
          <figure><img src="/img/kato.jpg" alt="加藤大治郎" width="500" height="400"></figure>
        </div>
        <div class="column reverse">
          <div>
            <h4>青山博一</h4>
            <p>
              WGP(現MotoGP)のGP250クラスは2009年で廃止となったが、その最後の年に4勝を挙げ世界の頂点に立った。原田哲也、加藤大治郎に続く、日本人3人目のGP250世界チャンピオン。現在は後進ライダーの育成や、MotoGPに参戦しているイデミツ ホンダ チーム アジア（2021年）を率いている。
            </p>
          </div>
          <figure><img src="/img/aoyama.jpg" alt="青山博一" width="500" height="400"></figure>
        </div>
        <div class="column">
          <div>
            <h4>藤波貴久</h4>
            <p>
              2021年でトライアル世界選手権にフル参戦を始めて26年目となる、日本を代表するトライアルライダー。2004年に最高峰クラスで8勝し、同クラスで日本人初となる世界チャンピオンを獲得した。フレンドリーなキャラクターと、アクセルを全開に、果敢にセクションにトライするスタイルから多くのファンを魅了している。
            </p>
          </div>
          <figure><img src="/img/hujinami.jpg" alt="藤波貴久" width="500" height="400"></figure>
        </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<style lang="scss">
 .content5 {
   h3 + p {
     margin-bottom: 30px;
   }
   .img-content__wrap {
     display: block;
   }
   img {
     width: 100%;
   }
 }
.column {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    &.reverse {
        flex-direction: row-reverse;
    }
    > * {
        width: 48%;
        margin: 0;
    }
}
.column-03{
  @media(min-width:768px){
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    >figure{
      width: 450px;
    }
    >div{
      width: calc(100% - 470px);;
    }
  }
}
.column-04{
  @media(min-width:768px){
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    &__right{
      width: 320px;
    }
    &__left{
      width: calc(100% - 340px);;
    }
  }
}
.column-05{
  @media(min-width:768px){
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    figure{
      width: 200px;
    }
    P{
      width: calc(100% - 250px);;
    }
  }
}
</style>